var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97341 19.9293H5.99113C4.89145 19.9293 3.99999 19.0378 4 17.9381L4.00008 5.99116C4.00008 4.89147 4.89154 4 5.99121 4H14.9515C16.0512 4 16.9427 4.89148 16.9427 5.99117V9.97351M7.4848 7.98234H13.4582M7.4848 10.9691H13.4582M7.4848 13.9559H10.4715M12.9603 17.1841L17.1841 12.9602L20 15.7761L15.7762 20H12.9603V17.1841Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/icon-contract.44d75bb5912f1032b40771ac43065298.svg";
export { ForwardRef as ReactComponent };